import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path
      d="M13 5l-2 2H6v10h5l2 2H4V5h9zm1 2l1.5 1.5L13 11h8v2h-8l2.5 2.5L14 17l-5-5 5-5z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);
